// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `th.MuiTableCell-head .MuiBadge-root svg,

th.MuiTableCell-head,
th.MuiTableCell-head .MuiButtonBase-root {
    color: #ffffff !important;
    opacity: 1 !important;
    font-size: 12px;
}
th.MuiTableCell-head svg {
    color: #ffffff;
    opacity: 1;
    font-size: 12px;
}
body {
    font-family: 'Poppins', sans-serif;
}

th.MuiTableCell-head .MuiBadge-root svg,
th.MuiTableCell-head .MuiTableSortLabel-icon {
    font-size: 14px;
}
th.MuiTableCell-head .MuiCollapse-wrapper {
    background-color: #ffffff !important;
    padding: 0px 5px 0px 5px !important;
    height: 25px !important;
}



th.MuiTableCell-head .MuiCollapse-wrapper .MuiIconButton-sizeSmall .MuiSvgIcon-fontSizeMedium {
    color: #000000c7;
}


th.MuiTableCell-head .MuiCollapse-wrapper .MuiInputAdornment-root span {
    cursor: pointer !important;
}

.css-1w86f15 {
    justify-content: center !important;
    padding-bottom: 30px;
}

.toast {
    display: none !important;
    visibility: hidden !important;
}

.toast--danger {
    display: none !important;
}
`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAAA;;;;IAII,yBAAyB;IACzB,qBAAqB;IACrB,eAAe;AACnB;AACA;IACI,cAAc;IACd,UAAU;IACV,eAAe;AACnB;AACA;IACI,kCAAkC;AACtC;;AAEA;;IAEI,eAAe;AACnB;AACA;IACI,oCAAoC;IACpC,mCAAmC;IACnC,uBAAuB;AAC3B;;;;AAIA;IACI,gBAAgB;AACpB;;;AAGA;IACI,0BAA0B;AAC9B;;AAEA;IACI,kCAAkC;IAClC,oBAAoB;AACxB;;AAEA;IACI,wBAAwB;IACxB,6BAA6B;AACjC;;AAEA;IACI,wBAAwB;AAC5B","sourcesContent":["th.MuiTableCell-head .MuiBadge-root svg,\n\nth.MuiTableCell-head,\nth.MuiTableCell-head .MuiButtonBase-root {\n    color: #ffffff !important;\n    opacity: 1 !important;\n    font-size: 12px;\n}\nth.MuiTableCell-head svg {\n    color: #ffffff;\n    opacity: 1;\n    font-size: 12px;\n}\nbody {\n    font-family: 'Poppins', sans-serif;\n}\n\nth.MuiTableCell-head .MuiBadge-root svg,\nth.MuiTableCell-head .MuiTableSortLabel-icon {\n    font-size: 14px;\n}\nth.MuiTableCell-head .MuiCollapse-wrapper {\n    background-color: #ffffff !important;\n    padding: 0px 5px 0px 5px !important;\n    height: 25px !important;\n}\n\n\n\nth.MuiTableCell-head .MuiCollapse-wrapper .MuiIconButton-sizeSmall .MuiSvgIcon-fontSizeMedium {\n    color: #000000c7;\n}\n\n\nth.MuiTableCell-head .MuiCollapse-wrapper .MuiInputAdornment-root span {\n    cursor: pointer !important;\n}\n\n.css-1w86f15 {\n    justify-content: center !important;\n    padding-bottom: 30px;\n}\n\n.toast {\n    display: none !important;\n    visibility: hidden !important;\n}\n\n.toast--danger {\n    display: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
